import React from 'react'
import styled from 'styled-components'
import { ErrorMessage } from 'formik'
import { formComponentDefaultStyles } from 'styles/defaults'
import FormErrorMessage from 'components/form-components/FormErrorMessage'
import PropTypes from 'prop-types'

const InputBlock = styled.div`
  margin-bottom: 10px;
`

const InputWrap = styled.div`
  position: relative;
  z-index: 0;
`

const Input = styled.textarea`
  ${formComponentDefaultStyles};
  resize: vertical;
  min-height: 80px;
`

const FormTextArea = ({ field, placeholder }) => (
  <InputBlock>
    <InputWrap>
      <Input placeholder={placeholder} {...field} />
    </InputWrap>
    <ErrorMessage component={FormErrorMessage} name={field.name} />
  </InputBlock>
)

FormTextArea.propTypes = {
  field: PropTypes.any,
  placeholder: PropTypes.string,
}

export default FormTextArea
